var _title, _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFinca = function SvgFinca(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 150 150",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Finca")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Finca",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(17.000000, 37.000000)",
    stroke: "#212121",
    strokeWidth: 3.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "streamline-icon-house-2@24x24-copy",
    transform: "translate(0.000000, 0.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1369863,25.5681818 L15.1369863,58.5227273 L32.2146119,58.5227273 L32.2146119,44.1051136 C32.2146119,39.5546402 36.0371537,35.8664773 40.7534247,35.8664773 C45.4696956,35.8664773 49.2922374,39.5546402 49.2922374,44.1051136 L49.2922374,58.5227273 L66.369863,58.5227273 L66.369863,25.5681818",
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 9.31506849,
    y1: 58.5227273,
    x2: 72.1917808,
    y2: 58.5227273,
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75905384,19.8117424 C8.72232742,21.7765152 9.56344508,24.1655303 11.6341035,25.1492424 C12.215341,25.425 12.8580555,25.5681818 13.5091532,25.5681818 L68.0001646,25.5681818 C70.3139367,25.5681818 72.1917808,23.7890152 72.1917808,21.5909091 C72.1917808,20.9731061 72.0408826,20.3632576 71.7502639,19.8117424 L63.8085483,9.65909091 L17.7007694,9.65909091 L9.75905384,19.8117424 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4657534,9.65909091 L17.4657534,5.11363636 C17.4657534,2.60454545 19.3626401,0.568181818 21.6998755,0.568181818 L59.8069738,0.568181818 C62.1442092,0.568181818 64.0410959,2.60454545 64.0410959,5.11363636 L64.0410959,9.65909091",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7945205,74.3087989 C24.5733577,74.9102501 29.3666849,73.2857422 32.8356164,69.8863636 C37.7129863,75.3819765 46.0447976,75.8153752 51.4467093,70.8534028 C51.7799817,70.5467806 52.0958661,70.225417 52.3972603,69.8863636 C57.2746301,75.3819765 65.6064414,75.8153752 71.0083531,70.8534028 C71.3416256,70.5467806 71.6575099,70.225417 71.9589041,69.8863636 C75.4278356,73.2857422 80.2211629,74.9102501 85,74.3087989",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,74.3087989 C4.77883714,74.9102501 9.57216438,73.2857422 13.0410959,69.8863636 C17.9184658,75.3819765 26.250277,75.8153752 31.6521887,70.8534028 C31.9854612,70.5467806 32.3013455,70.225417 32.6027397,69.8863636 C37.4801096,75.3819765 45.8119209,75.8153752 51.2138326,70.8534028 C51.547105,70.5467806 51.8629893,70.225417 52.1643836,69.8863636 C55.6333151,73.2857422 60.4266423,74.9102501 65.2054795,74.3087989",
    id: "Path-Copy"
  })), /*#__PURE__*/React.createElement("g", {
    id: "streamline-icon-swimming-pool-stairs@24x24",
    transform: "translate(85.000000, 31.500000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3703704,35 L18.3703704,5.83333333 C18.3703704,2.61138889 21.1973025,0 24.6851852,0 C28.1730679,0 31,2.61138889 31,5.83333333",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,35 L0,5.83333333 C0,2.61138889 2.8269321,0 6.31481481,0 C9.80269753,0 12.6296296,2.61138889 12.6296296,5.83333333",
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 21.4516129,
    x2: 18.3703704,
    y2: 21.4516129,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 29.3548387,
    x2: 18.3703704,
    y2: 29.3548387,
    id: "Path"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 12.4193548,
    x2: 18.3703704,
    y2: 12.4193548,
    id: "Path"
  }))))));
};
export default SvgFinca;